<!------
  @description 搜索栏
  @methods 无
  @param 无
  @special ''
------>
<template>
  <div class="main-search-box">
    <div class="nav-search" style="background: #ffffff">
      <div class="body-width flex-st">
        <div class="logo-box">
          <router-link to="/punchout-index"
            ><img
              src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/punchout/punchoutLogo.png"
              width="197px"
              height="67px"
              style="margin:10px;"
              alt="中控Platemate"
          /></router-link>
        </div>
        <div class="search flex-st">
          <input
            type="text"
            class="search-input"
            placeholder="搜索产品名称、品牌、型号、编号"
            v-model="searchName"
            @keyup.enter="searchByInput"
          />
          <div class="search-button" @click="searchByInput">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSideBar from '@/views/modules/punchout/components/leftSideBar'
export default {
  name: 'search',
  components: {
    LeftSideBar
  },
  data () {
    return {
      searchName: '',
      popuCategory: [], // 热搜类目
      shoppingCartCount: -1
    }
  },
  computed: {},
  created () {
    // this.getPopularCategory()
  },
  methods: {
    // 获取最热类目
    getPopularCategory () {
      this.$request
        .get(`/front/cross/commodity-center/search/category-list`)
        .then((res) => {
          this.popuCategory = res || []
        })
    },
    // 搜索事件
    searchByInput () {
      if (this.$route.query.search === this.searchName) {
        this.$router.push({
          name: 'punchoutGoodsList',
          query: {
            searchStr: this.searchName,
            categoryId: ''
          }
        })
        return
      }
      if (this.searchName) {
        this.$router.push({
          name: 'punchoutGoodsList',
          query: {
            searchStr: this.searchName,
            foregroundCategoryId: '',
            brandIdList: '',
            seriesIdList: '',
            attributeValueIdList: '',
            salesDesc: false,
            priceDesc: false,
            popularityDesc: false
          }
        })
      } else {
        this.$router.push({
          name: 'punchoutGoodsList',
          query: {
            search: '',
            foregroundCategoryId: '',
            brandIdList: '',
            seriesIdList: '',
            attributeValueIdList: '',
            salesDesc: false,
            priceDesc: false,
            popularityDesc: false
          }
        })
      }
    },
    // 热门搜索点击事件
    jumpj (id) {
      this.$router.push({
        name: 'punchoutGoodsList',
        query: {
          foregroundCategoryId: id,
          brandIdList: '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main-search-box {
  box-shadow: 0px 2px 9px 0px rgba(122,122,122,0.22);
  margin-bottom: 20px;
  .body-width {
    width: 1190px !important;
    margin: 0 auto;
    height: 100px;
    align-content: center;
    .logo-box {
      width: 197px;
      height: 67px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .search {
      width: 816px;
      margin-left: 42px;
      align-content: center;
      .search-input {
        width: 716px;
        height: 42px;
        border: 1px solid #1D65A8;
        box-sizing: border-box;
        padding-left: 10px;
      }
      .search-button {
        width: 100px;
        height: 42px;
        background: #1D65A8;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        i {
          font-size: 20px;
          color: #fff;
          font-weight: bold;
        }
      }
      .search-small {
        font-size: 12px;
        color: #666;
        padding-right: 10px;
        border-right: 1px #999999 solid;
        display: block;
        float: left;
        height: 12px;
        line-height: 14px;
        margin-top: 5px;
        padding-left: 10px;
        &:last-child{
          border: none;
        }
      }
    }
  }
}
</style>
